/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf31.png';

const MarketShareStep6 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Research &amp; Investigate"
    paragraph2={(
      <Fragment>
        To better understand the customer(s) in the game, we highly recommend that you conduct market
        research: review the Customer Analysis page to ensure that your features meet the minimum
        requirement for the customers that you’re targeting.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep6;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step6.js